import { createRoute } from '@tanstack/react-router';
import { authLayoutRoute } from '@/app/routes/roots';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { LoginPage } from './pages/LoginPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';

/**
 * Signed-out routes.
 *
 * There is no accept-invite route here, unlike the platform app: admin accounts
 * are seeded or created by another admin, never self-registered.
 *
 * Auth pages are NOT lazy-loaded — sign-in is the first screen an
 * unauthenticated visitor sees, and putting it behind an extra chunk request
 * makes the app feel slower exactly where first impressions are formed.
 */
export const loginRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/login',
  component: LoginPage,
  validateSearch: (search: Record<string, unknown>): { next?: string } => ({
    next: typeof search.next === 'string' && search.next.startsWith('/') ? search.next : undefined,
  }),
});

export const forgotPasswordRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/forgot-password',
  component: ForgotPasswordPage,
});

export const resetPasswordRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/reset-password',
  component: ResetPasswordPage,
  validateSearch: (search: Record<string, unknown>): { token?: string } => ({
    token: typeof search.token === 'string' ? search.token : undefined,
  }),
});

export const authRoutes = [loginRoute, forgotPasswordRoute, resetPasswordRoute];
